import './nf.css'

function Loader() {
    return (
        <div className="loader-spinner">
            <div className="spinner"></div>
        </div>
    );
}

export default Loader;